// Giả định bạn có 1 apiClient đã cấu hình

import api from "@/api";

const phongBanService = {
  // Hàm này gọi API đã có sẵn trong PhongBanController
  getActiveOptions() {
    // API trả về ApiResponse, chúng ta lấy response.data.data
    return api.get('/api/phong-ban/options'); 
  }
};

export default phongBanService;